export default "__VITE_ASSET__BJBBLaVc__"